import React, { useCallback } from 'react'
import { ButtonProps } from '@shared/components/button/model'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { Button } from '@shared/componentsStyled/Button'
import { yaCounter } from '@shared/pipes/ya-counter'
import styled from 'styled-components'

const logRegisterMain = (): void => yaCounter.utils.reachGoal('invest_register_main')

export interface MainProps {
	maxCashback: string
	buttonProps?: ButtonProps
}

export function SectionMain({ maxCashback, buttonProps }: MainProps): JSX.Element {
	const onClick = useCallback(
		(event) => {
			logRegisterMain()
			return buttonProps?.onClick?.(event)
		},
		[buttonProps?.onClick]
	)
	return (
		<Section>
			<ViewRoot>
				<ViewContent>
					<TextTitle>Получайте до&nbsp;26%&nbsp;годовых</TextTitle>
					<Text>
						<span>Зафиксированные в договоре выплаты</span>
						<span>Ежемесячные выплаты</span>
						<span>Поручительство <br /> от АО «Кредит Клаб Групп»</span>
					</Text>
					<ButtonStyled id={buttonProps?.id} onClick={onClick}>
						Рассчитать доход
					</ButtonStyled>
					<TextAlt>Артём Голоднов, акционер группы компаний Credit.Club</TextAlt>
				</ViewContent>
				<ViewImage>
					<Image
						name='KV-investor-fond-new.png'
						alt='Артём Голоднов, акционер группы компаний Credit.Club'
					/>
				</ViewImage>
			</ViewRoot>
		</Section>
	)
}

const ViewRoot = styled.div(({ theme }) => ({
	display: 'flex',
	backgroundColor: theme.colors.lightmint,
	borderRadius: 20,
	marginBottom: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		borderRadius: 40,
	},
}))

const ViewContent = styled.div(({ theme }) => ({
	flex: 1,
	paddingTop: 20,
	paddingLeft: 20,
	paddingRight: 20,
	zIndex: 1,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		paddingTop: 40,
		paddingLeft: 60,
		paddingRight: 0,
		maxWidth: '45%',
		marginRight: 'auto',
	},
}))
const ViewImage = styled.div(({ theme }) => ({
	display: 'none',
	flex: 1,

	picture: {
		[theme.mediaQueries.mediaMinWidthDesktop]: {
			display: 'flex',
			height: '100%',
			width: '100%',
		},
	},

	alignItems: 'center',
	justifyContent: 'flex-end',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		display: 'flex',
	},
}))

const TextTitle = styled.h1(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 10,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 20,
	},
}))

const Text = styled.p(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: '1fr',
	gap: theme.spacingsDesktop.s,
	...theme.typography.text18_24,
	marginBottom: 15,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text24_32,
		marginBottom: 30,
	},
}))

const ButtonStyled = styled(Button)(({ theme }) => ({
	marginBottom: 30,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 51,
	},
}))

const TextAlt = styled.p(({ theme }) => ({
	...theme.typography.text16_22,
	display: 'none',
	marginBottom: 30,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		display: 'block',
	},
	opacity: 0.5,
}))
